import React from 'react'
// nodejs library to set properties for components
import PropTypes from 'prop-types'
// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import NumberFormat from 'react-number-format'
import TextField from '@material-ui/core/TextField'

import customInputCondenseStyle from 'assets/jss/material-dashboard-pro-react/components/customInputCondenseStyle.jsx'

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        })
      }}
      thousandSeparator
      prefix="$ "
    />
  )
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}

function CustomInputCondense({ ...props }) {
  const { classes, formControlProps, labelText, id, labelProps, inputProps, error, disabled, success, helpText } = props //white, number, inputRootCustomClasses,
  // console.log(props)
  const labelClasses = classNames({
    [' ' + classes.labelRootError]: error,
    [' ' + classes.labelRootSuccess]: success && !error
  })
  // const underlineClasses = classNames({
  //   [classes.underlineError]: error,
  //   [classes.underlineSuccess]: success && !error,
  //   [classes.underline]: true,
  //   [classes.whiteUnderline]: white
  // })
  // const marginTop = classNames({
  //   [inputRootCustomClasses]: inputRootCustomClasses !== undefined
  // })
  // const inputClasses = classNames({
  //   [classes.input]: true,
  //   [classes.whiteInput]: white,
  //   [classes.rightInput]: number,
  //   [classes.disabled]: disabled
  // })
  // const textFiledClasses = classNames({
  //   [classes.textField]: true
  // })
  var formControlClasses
  if (formControlProps !== undefined) {
    formControlClasses = classNames(formControlProps.className, classes.formControl)
  } else {
    formControlClasses = classes.formControl
  }
  var helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error
  })
  return (
    <FormControl {...formControlProps} className={formControlClasses} style={{ padding: '0px' }}>
      {labelText !== undefined ? (
        <InputLabel className={classes.labelRoot + ' ' + labelClasses} htmlFor={id} {...labelProps}>
          {labelText}
        </InputLabel>
      ) : null}
      <TextField
        style={{ margin: '0px' }}
        // classes={{
        //   // input: inputClasses, // different than customer input, this is done by TextField, there is no implementation of inpu
        //   textField: textFiledClasses,
        //   root: marginTop
        //   // underline: underlineClasses
        // }}
        id={id}
        disabled={disabled}
        label={labelText}
        // {...inputProps}
        InputProps={{
          ...inputProps,
          inputComponent: NumberFormatCustom
        }}
      />
      {helpText !== undefined ? (
        <FormHelperText id={id + '-text'} className={helpTextClasses}>
          {helpText}
        </FormHelperText>
      ) : null}
    </FormControl>
  )
}

CustomInputCondense.propTypes = {
  classes: PropTypes.object.isRequired,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helpText: PropTypes.node
}

export default withStyles(customInputCondenseStyle)(CustomInputCondense)
